<template>
</template>

<script>
import {BCard,BButton} from 'bootstrap-vue'


export default {
    components:{
        BCard,
        BButton,
    },
    data(){
        return{
            
        }
    },
    mounted(){
    },
    methods:{
        
    }
}
</script>

<style>

</style>